import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import SweetAlert from 'react-bootstrap-sweetalert';
import _ from 'lodash';
import {
  UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';

import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';
import addNotification from '../../../components/notification';
import { getApprovalLevelList, deleteApprovalLevel } from '../../../app/store/actions/approvalLevel';
import InventoryHelpers from '../../../helpers/inventory';

class ApprovalLevelList extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value: (<>
          <i className="fas fa-home fa-fw m-t-10 m-r-5" />
          {' '}
          {I18n.t('BEE12' /* Início */)}
                </>),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE572' /* Inventário */) },
      { value: I18n.t('BEE2044' /* Alçada de aprovação */), active: true },
    ];

    this.state = {
      approvalLevelId: null,
      showModalDelete: false,
      defaultPageSize: 10,
      defaultSorted: [
        { id: 'branchName', desc: false },
      ],
      approvalLevelList: [],
    };

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={() => this.showDetail(rows.row)}>{I18n.t('BEE56' /* Detalhes */)}</DropdownItem>
                <DropdownItem onClick={() => this.showEdit(rows.row)}>{I18n.t('BEE57' /* Editar */)}</DropdownItem>
                <DropdownItem onClick={() => this.showCopy(rows.row)}>{I18n.t('BEE80' /* Copiar */)}</DropdownItem>
                <DropdownItem onClick={() => this.setState({ approvalLevelId: rows.original.id, showModalDelete: true })}>{I18n.t('BEE81' /* Eliminar */)}</DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2046' /* Tipo Inventário */),
        accessor: 'inventoryType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Cell: (rows) => (InventoryHelpers.inventoryType(rows.value)),
        Filter: ({ filter, onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option key="all" value="">{I18n.t('BEE793' /* Todos */)}</option>
            {InventoryHelpers.inventoryType().map(
              (element, index) => <option key={index} value={element.value}>{element.label}</option>,
            )}
          </select>
        ),
      },
    ];
  }

  componentDidMount() {
    this.approvalLevelList();
  }

  approvalLevelList = async () => {
    try {
      const approvalLevelList = await this.props.getApprovalLevelList();

      if (approvalLevelList && approvalLevelList.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE2044' /* Alçada de aprovação */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      } else {
        this.setState({
          approvalLevelList,
        });
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification('danger', I18n.t('BEE2044' /* Alçada de aprovação */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE2044' /* Alçada de aprovação */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  deleteRecord = async () => {
    const { approvalLevelId } = this.state;
    this.setState({ showModalDelete: false, approvalLevelId: null });
    try {
      const result = await this.props.deleteApprovalLevel(approvalLevelId);

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE2044' /* Alçada de aprovação */),
          I18n.t('BEE2031' /* Erro ao eliminar o registro */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE2044' /* Alçada de aprovação */),
          I18n.t('BEE2032' /* Registro eliminado com sucesso */),
          'top-right',
        );
        this.approvalLevelList();
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification('danger', I18n.t('BEE2044' /* Alçada de aprovação */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE2044' /* Alçada de aprovação */),
          I18n.t('BEE2031' /* Erro ao eliminar o registro */),
          'top-right',
        );
      }
    }
  };

  showDetail = (approvalLevel) => {
    this.props.history.push({
      pathname: ROUTES.APPROVAL_LEVEL_DETAIL,
      state: {
        approvalLevel: approvalLevel._original,
      },
    });
  };

  showCopy = (approvalLevel) => {
    this.props.history.push({
      pathname: ROUTES.APPROVAL_LEVEL_COPY,
      state: {
        approvalLevel: approvalLevel._original,
      },
    });
  };

  showEdit = (approvalLevel) => {
    this.props.history.push({
      pathname: ROUTES.APPROVAL_LEVEL_EDIT,
      state: {
        approvalLevel: approvalLevel._original,
      },
    });
  };

  render() {
    const {
      defaultPageSize, defaultSorted, showModalDelete, approvalLevelList,
    } = this.state;

    return (
      <>
        <Table
          breadcrumb={this.breadcrumb}
          downloadCSV
          headerTitle={I18n.t('BEE2044' /* Alçada de aprovação */)}
          wikiHelp={ROUTES.APPROVAL_LEVEL_HELP}
          panelHeaderProps={{
            onClickReload: this.approvalLevelList,
          }}
          actionButtons={(
            <div className="ml-auto">
              <Link to={ROUTES.APPROVAL_LEVEL_CREATE} className="btn btn-success btn-sm btn-rounded pl-2 pr-3">
                <i className="fa fa-plus mr-1" />
                {' '}
                {I18n.t('BEE2045' /* Incluir  de Aprovação */)}
              </Link>
            </div>
          )}
          filterable
          data={approvalLevelList}
          columns={this.tableColumns}
          expander
          defaultPageSize={defaultPageSize}
          defaultSorted={defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        {(showModalDelete
          && (
          <SweetAlert
            danger
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE101' /* Você tem certeza? */)}
            onConfirm={() => this.deleteRecord()}
            onCancel={() => this.setState({ showModalDelete: false, approvalLevelId: null })}
          >
            {I18n.t('BEE2047' /* Esta ação ira excluir o registro Alçada de aprovação */)}
          </SweetAlert>
          )
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  getApprovalLevelList: () => dispatch(getApprovalLevelList()),
  deleteApprovalLevel: (approvalLevelId) => dispatch(deleteApprovalLevel(approvalLevelId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ApprovalLevelList));
